import React, { useEffect, useRef } from "react";
import "./PopUp.scss";
import { CrossIcon } from "../Icons/CheckOutLogo";
import { PopUpCloseIcon } from "../Icons/CommonIcons";

interface PopupProps {
  isOpen: boolean;
  onClose: () => void;
  header?: string;
  body?: () => React.ReactNode;
  actionButtons?: React.ReactNode;
  closeButton?: boolean;
  width?: string,
  height?:string ;
  bodyClass?:string; 
  error?:string;
}

const PopUp: React.FC<PopupProps> = ({ isOpen, onClose, header, body, actionButtons, closeButton = false, width, error="" , height , bodyClass='' }) => {
  const popupRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }

  return (
    <div className="popup">
      <div className="popup-content" ref={popupRef} style={{ width: width , height:height }}>
        <div className="close-header">
          {header && <h5 className="popup-header">{header}</h5>}
          {closeButton && <button className="popup-close" onClick={onClose}>
            <PopUpCloseIcon />
          </button>}
        </div>
        {body && <div className={`popup-body ${bodyClass}`}>{error && <div className="statusError">{error}</div>}{body()}</div>}
        {actionButtons && <div className="popup-actions">{actionButtons}</div>}
      </div>
    </div>
  );
};

export default PopUp;
